import { IOBuffer } from 'iobuffer';
import { newDataBlock } from "./dataBlock/newDataBlock.js";
import { oldDataBlock } from "./dataBlock/oldDataBlock.js";
import { TheNewHeader, fileHeader } from "./fileHeader.js";
import { readLogBlock } from "./logBlock.js";
/**
 * Parses an SPC file.
 * @param  buffer - SPC file buffer.
 * @returns JSON-like object with information contained in the SPC file.
 */
export function parse(buffer) {
    const ioBuffer = new IOBuffer(buffer);
    const meta = fileHeader(ioBuffer);
    if (meta instanceof TheNewHeader) {
        //new format
        const spectra = newDataBlock(ioBuffer, meta);
        const logs = meta.logOffset !== 0 ? readLogBlock(ioBuffer, meta.logOffset) : null;
        return { meta, spectra, logs };
    }
    else {
        //old format
        return {
            meta,
            spectra: oldDataBlock(ioBuffer, meta),
        };
    }
}
//# sourceMappingURL=parse.js.map